import * as tslib_1 from "tslib";
import React from 'react';
import classnames from 'classnames';
import TooltipLayout from '../TooltipLayout/TooltipLayout';
import s from './TooltipContent.scss';
var defaultProps = {
    oneLine: false,
    noPadding: false,
    showArrow: true,
};
var TooltipContent = /** @class */ (function (_super) {
    tslib_1.__extends(TooltipContent, _super);
    function TooltipContent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TooltipContent.prototype.render = function () {
        var _a = this.props, oneLine = _a.oneLine, noPadding = _a.noPadding, children = _a.children, wrapperClassName = _a.wrapperClassName, contentClassName = _a.contentClassName, arrowClassName = _a.arrowClassName, positionOnly = _a.positionOnly, layoutProps = tslib_1.__rest(_a, ["oneLine", "noPadding", "children", "wrapperClassName", "contentClassName", "arrowClassName", "positionOnly"]);
        var styles = positionOnly ? {} : s;
        return (React.createElement(TooltipLayout, tslib_1.__assign({}, layoutProps, { wrapperClassName: classnames(styles['tooltip-wrapper'], wrapperClassName), arrowClassName: classnames(arrowClassName, styles['arrow']), contentClassName: classnames(styles['tooltip-content'], oneLine && styles['one-line'], noPadding && styles['no-padding'], contentClassName) }), children));
    };
    TooltipContent.defaultProps = defaultProps;
    return TooltipContent;
}(React.Component));
export { TooltipContent };
export default TooltipContent;
//# sourceMappingURL=TooltipContent.js.map